import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { stepsSelector, isCompletingSelector, errorSelector } from '../selectors/wizardSelectors';
import { updateStep, getSetupStateRequest } from '../actions/wizardActions';
import QR from '../components/QR/QR';

const mapStateToProps = createStructuredSelector({
    steps: stepsSelector,
    isCompleting: isCompletingSelector,
    error: errorSelector
});

const mapDispatchToProps = {
    updateStep,
    getSetupStateRequest
};

export default withTranslation(['common', 'validations'])(
    connect(mapStateToProps, mapDispatchToProps)(QR)
);
